import { call, put, takeLatest } from 'redux-saga/effects';
import { ClaimApi, UpdateClaimParams, GetClaimParams } from '@apis/ClaimApi';
import { userClaimUpdate, userClaimFetch, stateUpdate, StateUpdatePayload } from './action';
import { SagaPayload } from '@utils/typescript';
import { Claim } from '@models/Claim';
import { history } from '@utils/history';

function* handleUserClaimUpdate({ payload }: SagaPayload<UpdateClaimParams>) {
  const state: StateUpdatePayload = { claim: null };
  try {
    state.claim = (yield call(ClaimApi.put, payload)) as Claim;
    const { claimableType, claimableId } = state.claim;
    history.navigate(`/user-dashboard/claim/${claimableType}/${claimableId}`, { replace: true });
    yield put(stateUpdate(state));
  } catch {}
}

function* handleUserClaimFetch({ payload }: SagaPayload<GetClaimParams>) {
  const state: StateUpdatePayload = { claim: null };
  try {
    state.claim = (yield call(ClaimApi.get, payload)) as Claim;
    yield put(stateUpdate(state));
  } catch {}
}

export default function* () {
  yield takeLatest(userClaimUpdate, handleUserClaimUpdate);
  yield takeLatest(userClaimFetch, handleUserClaimFetch);
}
